export class ProblemPreprocessor {
  public static lim(element: HTMLElement): void {
    element = element?.querySelector('.lim.element');

    if (!element) {
      return;
    }

    const rows: HTMLCollection = element.querySelector('tbody').children;

    const cells: NodeListOf<HTMLTableCellElement> = rows[2].querySelectorAll('td');

    let height: number = 0;

    const spans: HTMLSpanElement[] = Array.from(cells)
      .map((cell: HTMLTableCellElement): HTMLSpanElement => cell.querySelector('span'));

    height = Math.max(...spans.map((span: HTMLSpanElement): number => span.offsetHeight));

    spans.forEach((span: HTMLSpanElement): string => span.style.height = `${height}px`);

    height = Math.max((rows[0] as HTMLTableElement).offsetHeight, (rows[2] as HTMLTableElement).offsetHeight);

    (rows[0] as HTMLTableElement).style.height = `${height}px`;
    (rows[2] as HTMLTableElement).style.height = `${height}px`;

    const closestSup: HTMLElement = element.closest('sup');

    if (closestSup) {
      closestSup.style.verticalAlign = 'text-bottom';
    }
  }

  public static fraction(element: HTMLElement): void {
    element = element?.querySelector('.fraction.element');

    if (!element) {
      return;
    }

    const rows: HTMLCollection = element.querySelector('tbody').children;

    const height: number = Math.max((rows[0] as HTMLTableElement).offsetHeight, (rows[1] as HTMLTableElement).offsetHeight);

    (rows[0] as HTMLTableElement).style.height = `${height}px`;
    (rows[1] as HTMLTableElement).style.height = `${height}px`;

    const closestSup: HTMLElement = element.closest('sup');
    if (closestSup) {
      closestSup.style.top = '';
      closestSup.style.verticalAlign = 'text-bottom';
    }
  }

  public static nLogarithm(element: HTMLElement): void {
    const rows: HTMLElement[] = this.getRows(element, '.nLogarithm');
    if (rows.length >= 2) {
      const height = Math.max(rows[0].offsetHeight, rows[1].offsetHeight);
      (rows[0] as HTMLTableElement).style.height = `${height}px`;
      (rows[1] as HTMLTableElement).style.height = `${height}px`;
    }
  }

  public static logarithm(element: HTMLElement): void {
    const rows: HTMLElement[] = this.getRows(element, '.logarithm');
    if (rows.length >= 2) {
      const height = Math.max(rows[0].offsetHeight, rows[1].offsetHeight);
      (rows[0] as HTMLTableElement).style.height = `${height}px`;
      (rows[1] as HTMLTableElement).style.height = `${height}px`;
    }
  }

  private static getRows(element: HTMLElement, elementClass: string): HTMLElement[] {
    const nodes = element.querySelector(`${elementClass} tbody`)?.childNodes as NodeListOf<HTMLElement>;

    if (nodes) {
      const trItems = Array.from(nodes).filter(node => node.nodeName === 'TR');
      return trItems.length >= 2 ? trItems : [];
    }

    return [];
  }
}
